import { render, staticRenderFns } from "./LoadTurn.vue?vue&type=template&id=2759ca65&"
import script from "./LoadTurn.vue?vue&type=script&lang=js&"
export * from "./LoadTurn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports